module.exports = __webpack_public_path__ + "static/media/vacuderma-2.28ef19c9.jpg";